import React from "react";
import { Link } from "react-router-dom";
import HeaderMenuItem from "../HeaderMenuItem";
import { loggedInSupportItems, accountMenuItems } from "../constants";
import avatarIcon from "../../../assets/icons/avatar.svg";
import { PowerSettingsNewOutlined } from "@material-ui/icons";
import classes from "@css/components/website/Header.module.css";
import supportIcon from "../../../assets/icons/support.svg";

interface ProviderLoggedInProps {
  isOpaque: boolean;
  profile: any;
  isApproved: boolean;
  isBanned: boolean;
  isAbbreviated: boolean;
  warriorBookings: any[];
  signOut: () => void;
}

function ProviderLoggedIn({ isOpaque, profile, isApproved, isBanned, isAbbreviated, warriorBookings, signOut }: ProviderLoggedInProps) {
  const primaryButtonClasses = isOpaque ? classes.primaryButton : classes.primaryButtonDark;
  const outlinedButtonClasses = isOpaque ? classes.outlinedButtonDark : classes.outlinedButton;

  const signOutMenuItem = {
    label: "Sign Out",
    icon: <PowerSettingsNewOutlined color="primary" />,
    func: signOut,
  };

  const sideLinks = isBanned
    ? accountMenuItems().providerSideNavLinks.filter((link: any) => link.url === "/account")
    : accountMenuItems(profile).providerSideNavLinks.filter((link) => !link.hidden);

  return (
    <div className={classes.buttonContainer}>
      <div className={classes.buttonContainerInner}>
        {!isBanned && isApproved && (
          <>
            <Link to="/get_tasks" className={primaryButtonClasses}>
              Claim Task
            </Link>
            {isAbbreviated && warriorBookings.length > 0 && (
              <Link to="/tasks" className={outlinedButtonClasses}>
                My Tasks
              </Link>
            )}
          </>
        )}

        <span style={{ margin: "0 16px" }}>
          <HeaderMenuItem isOpaque={isOpaque} name="Support" icon={supportIcon} menuItems={loggedInSupportItems} showDropdownArrow={false} />
        </span>

        <HeaderMenuItem isOpaque={isOpaque} icon={avatarIcon} name="" menuItems={[...sideLinks, signOutMenuItem]} showDropdownArrow />
      </div>
    </div>
  );
}

export default ProviderLoggedIn;
